module.exports = __webpack_public_path__ + "static/img/History Books.9e3b202.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/History Books.png
// module id = 2238
// module chunks = 61